import { ReactNode } from "react";

interface FeatureCardProps {
  title: string;
  description: string;
  icon?: ReactNode;
  avatarGroup?: ReactNode;
  className?: string;
}

export default function FeatureCard({
  title,
  description,
  icon,
  avatarGroup,
  className = "",
}: FeatureCardProps) {
  return (
    <div className={`relative flex-1 min-w-[320px] pt-6 ${className}`}>
      {/* Icon or Avatar Group - positioned above the card */}
      {(icon || avatarGroup) && (
        <div className="absolute left-1/2 -translate-x-1/2 top-[-8px] z-10">
          {avatarGroup ? (
            avatarGroup
          ) : (
            <div className="relative bg-[var(--color-bg-surface)] border border-[var(--color-border-default)] rounded-xl p-1 shadow-[0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              {icon}
              {/* Skeuomorphic inner shadow */}
              <span className="absolute inset-0 pointer-events-none rounded-xl shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05)]" />
            </div>
          )}
        </div>
      )}

      {/* Card body */}
      <div className="bg-[var(--color-bg-page)] rounded-2xl pt-[52px] pb-8 px-6">
        <div className="text-center space-y-1">
          <h3 className="text-[18px] font-semibold text-[var(--color-text-primary)] leading-7">
            {title}
          </h3>
          <p className="text-[16px] font-normal text-[var(--color-text-secondary)] leading-6">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

// Avatar Group component for "Chat with Characters" feature
export function AvatarGroup() {
  // Placeholder avatar colors representing different characters
  const avatars = [
    "bg-gradient-to-br from-[#8B7355] to-[#5D4E37]", // Brown
    "bg-gradient-to-br from-[#E8C4A0] to-[#C9A882]", // Beige
    "bg-gradient-to-br from-[#6B8E9F] to-[#4A6B7A]", // Blue-gray
    "bg-gradient-to-br from-[#5D5D5D] to-[#3D3D3D]", // Gray
    "bg-gradient-to-br from-[#D4A574] to-[#B8896A]", // Tan
    "bg-gradient-to-br from-[#8B6F5C] to-[#6B5347]", // Dark brown
  ];

  return (
    <div className="flex -space-x-3">
      {avatars.map((gradient, index) => (
        <div
          key={index}
          className={`w-10 h-10 rounded-full ${gradient} border border-black/8 shadow-[0px_0px_0px_1.5px_white]`}
        />
      ))}
    </div>
  );
}
